
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeCruiseFilled as ObiVesselTypeCruiseFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-cruise-filled.js';
 
 
 

 
 export const ObiVesselTypeCruiseFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-cruise-filled',
   elementClass: ObiVesselTypeCruiseFilledElement,
   events: {
     
   }
  });
 
 